function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import find from 'lodash/find';
import get from 'lodash/get';
import { AppContext } from 'context';
import LinkTile from 'components/LinkTile';
import intlShape from 'shapes/intlShape';
import App from 'modules/App';
import messages from '../../messages';
var _React_PureComponent;
class ProfileBox extends (_React_PureComponent = React.PureComponent) {
    get countryName() {
        const { countryCode: alpha2Code } = this.props.identity;
        const country = find(this.props.countries, {
            alpha2Code
        });
        return get(this.props.localizationResources, [
            country.nameKey,
            'value'
        ], country.englishName);
    }
    get headMessage() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.countryName,
                /*#__PURE__*/ _jsx("span", {
                    className: "text--secondary text--normal mx-3",
                    children: "|"
                }),
                this.profileName
            ]
        });
    }
    get imageFile() {
        const { countryCode } = this.props.identity;
        return `${countryCode}.svg`;
    }
    get profileName() {
        const { scope } = this.props.identity;
        return this.props.intl.formatMessage(messages.scopes[scope]);
    }
    render() {
        return /*#__PURE__*/ _jsx(LinkTile, {
            labelMessage: this.headMessage,
            image: /*#__PURE__*/ _jsx("img", {
                src: `/aid/assets/svg/flags/${this.imageFile}`,
                alt: this.countryName
            }),
            hasBorder: true,
            hasImageBorder: true
        });
    }
}
_define_property(ProfileBox, "contextType", AppContext);
_define_property(ProfileBox, "propTypes", {
    // Explicit props
    identity: PropTypes.shape({
        countryCode: PropTypes.string.isRequired,
        scope: PropTypes.string.isRequired
    }),
    // Implicit props
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    intl: intlShape.isRequired
});
const mapStateToProps = (state)=>({
        countries: App.selectors.countries(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const ConnectedProfileBox = connect(mapStateToProps)(ProfileBox);
export default injectIntl(ConnectedProfileBox);
